import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnquiriesModule } from '@features/enquiries/enquiries.module';
import { FilterBarModule } from '@addToEvent/add-to-event-ui';
import { MaterialModule } from '@shared/material/material.module';
import { FormComponentsControlDirective } from '../../shared/directives/forms/form-components-wrapper.directive';
import { FullNamePipe } from '../../shared/pipes/full-name.pipe';
import { NotificationsService } from '../../shared/services/notifications/notifications.service';
import { AddCustomerComponent } from './customer-add/customer-add.control';
import { EditCustomerComponent } from './customer-edit/customer-edit.control';
import { CustomerEditDialogComponent } from './customer-edit-dialog/customer-edit-dialog.control';
import { CustomerFormComponent } from './customer-form/customer-form.control';
import { CustomerProfileComponent } from './customer-profile/customer-profile.control';
import { CustomerTileComponent } from './customer-tile/customer-tile.control';
import { CustomersRoutingModule } from './customers-routing.module';
import { CustomersComponent } from './customers.control';
import { CustomerService } from './services/customer.service';

@NgModule({
  imports: [CommonModule, CustomersRoutingModule, FormsModule, ReactiveFormsModule, MaterialModule, FilterBarModule, FormComponentsControlDirective, EnquiriesModule, FullNamePipe],
  declarations: [
    AddCustomerComponent,
    CustomerFormComponent,
    CustomerEditDialogComponent,
    EditCustomerComponent,
    CustomersComponent,
    CustomerTileComponent,
    CustomerProfileComponent
  ],
  providers: [NotificationsService, CustomerService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomersModule {}
